import React from "react";
import { ModalHeader } from "../SignInBar/SignInBarHelpers";

interface EmailSentComponentProps {
  message: string;
}

const EmailSentComponent: React.FC<EmailSentComponentProps> = ({
  message,
  onCloseClick,
}) => {
  return (
    <>
      <ModalHeader onCloseClick={onCloseClick} />
      <div className="email-sent-container">
        <div className="empty-div"></div>
        <svg className="sentIcon" id="email-sent-icon">
          <use xlinkHref="/svg/send.svg#send"></use>
        </svg>
        <div className="title-container">
          <h2 className="sentIcon-Title">Email sent to your inbox</h2>
        </div>
        <div className="description-container">
          <p className="sentIcon-Description">{message}</p>
        </div>
      </div>
    </>
  );
};

export default EmailSentComponent;
